<template>
  <div class="row">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>